/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const configState = () => ({
  logo_url: null,
  bb_branding: true,
  cod: false,
  bb_loyalty: false,
  cod_charge: 50,
  shipping_charge: true,
  shipping_charge_amount: 50,
  shipping_charge_max_threshold: 499,
  max_cod_amount: 5000
});

const configSlice = createSlice({
  name: "config",
  initialState: configState(),
  reducers: {
    setConfig(state, { payload }) {
      state.cod = payload?.cod || state.cod;
      state.logo_url = payload?.logo_url || state.logo_url;
      state.bb_loyalty = payload?.bb_loyalty || state.bb_loyalty;
      state.cod_charge = payload?.cod_charge || state.cod_charge;
      state.shipping_charge_amount =
        payload?.shipping_charge_amount || state.shipping_charge_amount;
      state.bb_branding = payload?.bb_branding || state.bb_branding;
      state.shipping_charge = payload?.shipping_charge || state.shipping_charge;
      state.shipping_charge_max_threshold =
        payload?.shipping_charge_max_threshold ||
        state.shipping_charge_max_threshold;
      state.max_cod_amount = payload?.max_cod_amount || state.max_cod_amount;
    }
  }
});

export const { setConfig } = configSlice.actions;
export default configSlice.reducer;
